import React from 'react'
import classes from './cardTitle.module.css'

const variants = {
    BOLD: classes.titleBold,
    SEMIBOLD: classes.titleSemiBold,
}

const CardTitle = ({
    children,
    variant = '',
    courseType = '',
    hasEnrolled,
    isClass,
}) => {
    return (
        <p className={[classes.title, variants[variant]].join(' ')}>
            {children}
            {courseType && (
                <span className={classes.titleTag}>
                    {courseType.replace(/_/g, ' ')}
                </span>
            )}
            {hasEnrolled && (
                <span
                    className={classes.titleTag}
                    style={{ background: '#eb6324', color: '#fff' }}
                >
                    {isClass ? 'Registered' : 'Enrolled'}
                </span>
            )}
        </p>
    )
}

export default CardTitle
